module.exports = __webpack_public_path__ + "img/play-fill.75805e45.svg";